import { render } from "./ForgotUsername.vue?vue&type=template&id=115b9658&scoped=true&lang=pug"
import script from "./ForgotUsername.vue?vue&type=script&lang=js"
export * from "./ForgotUsername.vue?vue&type=script&lang=js"

import "./ForgotUsername.vue?vue&type=style&index=0&id=115b9658&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115b9658"]])

export default __exports__